import { useMemo, useState } from 'react';
import { Section } from '@farmersdog/corgi-x';

import { ExtendedText } from 'src/pages/HomepageRedesign/components';
import { MobileReviewsCarousel } from './MobileReviewsCarousel';
import { CategoryButton } from './CategoryButton';

import { categories, ReviewCategory } from './categories';

import { getReorderedReviewsByCategory } from './getReorderedReviewsByCategory';

import styles from './ReviewsCarousel.module.css';

export const ReviewsCarousel = () => {
  const [selectedCategory, setSelectedCategory] = useState<ReviewCategory>(
    ReviewCategory.OverallHealth
  );

  const filteredItems = useMemo(() => {
    return getReorderedReviewsByCategory({
      category: selectedCategory,
    });
  }, [selectedCategory]);

  return (
    <Section aria-label="Customer Reviews section">
      <ExtendedText
        as="h2"
        align="center"
        color="kale-3"
        variant="heading-28"
        weight="black"
      >
        See the fresh
        <br />
        food difference
      </ExtendedText>

      <div className={styles.categories}>
        {Object.entries(categories).map(([key, label]) => (
          <CategoryButton
            key={key}
            isActive={key === selectedCategory}
            onClick={() => setSelectedCategory(key as ReviewCategory)}
          >
            {label}
          </CategoryButton>
        ))}
      </div>

      <div className={styles.mobile}>
        <MobileReviewsCarousel
          items={filteredItems}
          selectedCategory={selectedCategory}
        />
      </div>
      <div className={styles.desktop}>TODO: add desktop component</div>
    </Section>
  );
};
